export const ESTADOS = [
  { valor: 'AC', rotulo: 'Acre' },
  { valor: 'AL', rotulo: 'Alagoas' },
  { valor: 'AP', rotulo: 'Amapé' },
  { valor: 'AM', rotulo: 'Amazonas' },
  { valor: 'BA', rotulo: 'Bahia' },
  { valor: 'CE', rotulo: 'Ceará' },
  { valor: 'DF', rotulo: 'Distrito Federal' },
  { valor: 'ES', rotulo: 'Espírito Santo' },
  { valor: 'GO', rotulo: 'Goiás' },
  { valor: 'MA', rotulo: 'Maranhão' },
  { valor: 'MT', rotulo: 'Mato Grosso' },
  { valor: 'MS', rotulo: 'Mato Grosso do Sul' },
  { valor: 'MG', rotulo: 'Minas Gerais' },
  { valor: 'PA', rotulo: 'Pará' },
  { valor: 'PB', rotulo: 'Paraíba' },
  { valor: 'PR', rotulo: 'Paraná' },
  { valor: 'PE', rotulo: 'Pernambuco' },
  { valor: 'PI', rotulo: 'Piauí' },
  { valor: 'RJ', rotulo: 'Rio de Janeiro' },
  { valor: 'RN', rotulo: 'Rio Grande do Norte' },
  { valor: 'RS', rotulo: 'Rio Grande do Sul' },
  { valor: 'RO', rotulo: 'Rondônia' },
  { valor: 'RR', rotulo: 'Roraima' },
  { valor: 'SC', rotulo: 'Santa Catarina' },
  { valor: 'SP', rotulo: 'São Paulo' },
  { valor: 'SE', rotulo: 'Sergipe' },
  { valor: 'TO', rotulo: 'Tocantins' },
];

export const PERMISSOES = [
  { valor: 'super', rotulo: 'Super' },
  { valor: 'admin', rotulo: 'Administrador' },
  { valor: 'comum', rotulo: 'Comum' },
  { valor: 'conteudista', rotulo: 'Conteudista' },
];

export const TECNOLOGIAS = [
  { valor: 'lti', rotulo: 'LTI' },
  { valor: 'proprietaria', rotulo: 'Proprietária' },
  { valor: 'iesde', rotulo: 'IESDE' },
];

export const TIPOS_CURSOS_IESDE = [
  { valor: 'P', rotulo: 'Preparatórios/Pacotes (P)' },
  { valor: 'C', rotulo: 'Atualização (C)' },
  { valor: 'E', rotulo: 'Extensão (E)' },
];

export const CARGA_HORARIA = [
  { valor: '30', rotulo: '30 horas' },
  { valor: '40', rotulo: '40 horas' },
  { valor: '80', rotulo: '80 horas' },
  { valor: '100', rotulo: '100 horas' },
  { valor: '120', rotulo: '120 horas' },
  { valor: '180', rotulo: '180 horas' },
  { valor: '200', rotulo: '200 horas' },
  { valor: '210', rotulo: '210 horas' },
  { valor: '240', rotulo: '240 horas' },
  { valor: '300', rotulo: '300 horas' },
];

export const FRETES = [
  { valor: 4014, rotulo: 'Sedex' },
  { valor: 4510, rotulo: 'PAC' },
];

export const BANDEIRAS = [
  { valor: 'Mastercard', rotulo: 'MasterCard' },
  { valor: 'Visa', rotulo: 'Visa' },
  { valor: 'Amex', rotulo: 'Amex' },
  { valor: 'Elo', rotulo: 'Elo' },
  { valor: 'Hipercard', rotulo: 'Hipercard' },
];

export const SIM_OU_NAO = [
  { valor: 0, rotulo: 'Não' },
  { valor: 1, rotulo: 'Sim' },
];

export const FORMATO_CERTIFICADO = [
  { valor: 1, rotulo: 'Digital' },
  { valor: 2, rotulo: 'Físico' },
];

export const STATUS_SOLICITACAO = [
  { valor: 0, rotulo: 'Aguardando atendimento' },
  { valor: 1, rotulo: 'Em atendimento' },
  { valor: 2, rotulo: 'Finalizado' },
];

export const TIPOS_DE_TAREFAS_FILTRO = [
  { valor: 'producao-de-ua', rotulo: 'Produção de UA' },
  { valor: 'upload-de-videos-para-ua', rotulo: 'Upload de vídeos para UA' },
];

export const TIPOS_DE_TAREFAS = [
  { valor: 'producao-de-ua', rotulo: 'Produção de UA' },
];

export const TIPOS_DE_TAREFAS_PRODUCAO_DE_UA = [
  { valor: 'upload-de-videos-para-ua', rotulo: 'Upload de vídeos para UA' },
];

export const NUMBER_OF_PARAGRAPHS = [
  { valor: 1, rotulo: '1' },
  { valor: 2, rotulo: '2' },
  { valor: 3, rotulo: '3' },
  { valor: 4, rotulo: '4' },
  { valor: 5, rotulo: '5' },
];

export const DENOMINACOES_DO_CERTIFICADO = [
  { valor: 1, rotulo: 'Aperfeiçoamento' },
  { valor: 2, rotulo: 'Aprimoramento' },
  { valor: 3, rotulo: 'Atualização' },
  { valor: 4, rotulo: 'Capacitação' },
  { valor: 5, rotulo: 'Curso Livre' },
       { valor: 6, rotulo: 'Educação Continuada' },
  { valor: 7, rotulo: 'Extensão' },
];

export const IMAGENS = ['image/png', 'image/jpeg', 'image/webp'];

export const POWERPOINT = [
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
];

export const VIDEOS = [
  'video/mp4',
  'video/x-msvideo',
];

export const LEGENDAS = ['text/vtt'];

export const MASCARA_CPF = '000.000.000-00';

export const MASCARA_CNPJ = '00.000.000/0000-00';

export const MASCARA_TELEFONE = '(00) 0000[0]-0000';

export const MASCARA_CEP = '00000-000';

export const MASCARA_DATA_VENCIMENTO = '00/00';

export const LIMITE_DE_CARGA_HORARIA = 500;
